export const getEditRightsSuccess = (name: string): string =>
  `Права для роли "${name}" обновлены`;
export const getEditRightsError = (name: string): string =>
  `Не удалось обновить права для роли "${name}"`;
